var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLinkSocials = function SvgLinkSocials(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#191A1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4546 20.7768C18.7881 21.2227 19.2136 21.5916 19.7023 21.8586C20.1909 22.1256 20.7312 22.2843 21.2866 22.3241C21.842 22.3639 22.3995 22.2837 22.9212 22.0891C23.4429 21.8945 23.9166 21.59 24.3103 21.1962L26.6401 18.8663C27.3475 18.134 27.7389 17.1531 27.73 16.135C27.7212 15.1169 27.3128 14.1429 26.5928 13.423C25.8729 12.703 24.8989 12.2946 23.8808 12.2858C22.8627 12.2769 21.8818 12.6683 21.1494 13.3757L19.8137 14.7037",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5612 19.2227C21.2277 18.7768 20.8022 18.4079 20.3135 18.1409C19.8249 17.874 19.2846 17.7152 18.7292 17.6754C18.1738 17.6357 17.6163 17.7158 17.0946 17.9104C16.5729 18.105 16.0992 18.4096 15.7055 18.8034L13.3757 21.1332C12.6683 21.8656 12.2769 22.8464 12.2858 23.8646C12.2946 24.8827 12.703 25.8566 13.423 26.5766C14.1429 27.2965 15.1169 27.7049 16.135 27.7138C17.1531 27.7226 18.134 27.3312 18.8663 26.6239L20.1944 25.2959",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkSocials, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/link-socials.5fe8d61b.svg";
export { ForwardRef as ReactComponent };